import createPersistedState from 'vuex-persistedstate'

export default ({ store }) => {
  if (process.server) return

  console.warn('Initializing localStorage vuex-persistedstate (flat, safe)')

  const modules = ['cart'] // add any other localStorage-backed modules here

  modules.forEach(moduleName => {
    createPersistedState({
      key: `${moduleName}`,
      paths: [moduleName],
      storage: window.localStorage,

      getState: (key, storage) => {
        const raw = storage.getItem(key)
        if (!raw) return { [moduleName]: {} }
        try {
          const parsed = JSON.parse(raw)
          const value =
            parsed && typeof parsed === 'object' && Object.prototype.hasOwnProperty.call(parsed, moduleName)
              ? parsed[moduleName] // unwrap legacy { moduleName: {...} }
              : parsed
          return { [moduleName]: value ?? {} }
        } catch (e) {
          console.warn(`[local] Corrupted JSON for "${key}", clearing.`, e)
          storage.removeItem(key)
          return { [moduleName]: {} }
        }
      },

      setState: (key, state, storage) => {
        try {
          storage.setItem(key, JSON.stringify(state[moduleName] || {}))
        } catch (e) {
          console.warn(`[local] Failed to persist "${key}"`, e)
        }
      }
    })(store)
  })
}
